import { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_source-scout-4/artifacts/hca8zcbd_WhatsApp%20Image%202026-02-28%20at%2022.18.51.jpeg";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#hero', label: 'Home' },
    { href: '#products', label: 'Products' },
    { href: '#services', label: 'Services' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass-nav shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#hero" data-testid="logo-link" className="flex items-center">
            <img
              src={LOGO_URL}
              alt="Tejas Info Solutions"
              className="h-12 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`font-medium tracking-wider uppercase text-sm transition-colors duration-300 ${
                  isScrolled
                    ? 'text-slate-700 hover:text-orange-500'
                    : 'text-slate-100 hover:text-orange-400'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <span
              data-testid="header-phone"
              className={`flex items-center gap-2 font-semibold ${
                isScrolled ? 'text-slate-900' : 'text-slate-100'
              }`}
            >
              <Phone className="h-4 w-4 text-orange-500" />
              091363 51639
            </span>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} />
            ) : (
              <Menu className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t border-slate-200"
        >
          <nav className="flex flex-col py-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className="px-6 py-3 font-medium text-slate-700 hover:bg-slate-50 hover:text-orange-500 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <div className="px-6 py-3 border-t border-slate-100 mt-2">
              <span className="flex items-center gap-2 font-semibold text-slate-900">
                <Phone className="h-4 w-4 text-orange-500" />
                091363 51639
              </span>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
